module.exports = __webpack_public_path__ + "static/media/CAKE.6d494764.svg";